import request from '@/utils/request'



// 查询客户回访记录列表
export function queryListVisit(query) {
  return request({
    url: '/scrm/visit/listVisit',
    method: 'get',
    params: query
  })
}



// 查询客户回访记录列表
export function listVisit(query) {
  return request({
    url: '/scrm/visit/list',
    method: 'get',
    params: query
  })
}

// 查询客户回访记录详细
export function getVisit(visitId) {
  return request({
    url: '/scrm/visit/' + visitId,
    method: 'get'
  })
}

// 新增客户回访记录
export function addVisit(data) {
  return request({
    url: '/scrm/visit',
    method: 'post',
    data: data
  })
}

// 修改客户回访记录
export function updateVisit(data) {
  return request({
    url: '/scrm/visit',
    method: 'put',
    data: data
  })
}

// 删除客户回访记录
export function delVisit(visitId) {
  return request({
    url: '/scrm/visit/' + visitId,
    method: 'delete'
  })
}

// 导出客户回访记录
export function exportVisit(query) {
  return request({
    url: '/scrm/visit/export',
    method: 'get',
    params: query
  })
}